import * as React from "react"
import { PageProps, Link, HeadFC } from "gatsby"

import Layout from "../components/layout"
import Seo from "../components/seo"
import { StaticImage } from "gatsby-plugin-image"

type DataProps = {}

const LandingPage: React.FC<PageProps<DataProps>> = ({ data, location }) => (
  <Layout>
    <div className="hero">
      <StaticImage
        src="../images/logo-black.webp"
        placeholder="none"
        width={353}
        height={296}
        alt="Shubhi Shrivastava"
      />
      <h1>Shubhi Shrivastava</h1>
      <h3>UX Designer | Photographer | Artist</h3>
    </div>
    <div className="flex-column-center">
      <div className="text-highlight-container">
        <p>
          I am a design professional with 11+ years of experience in the service
          design industry. I am a multidisciplinary designer with a background
          in engineering. I specialize in UX design, visual design, design
          strategy and design research. My work spans across multiple domains
          such as banking and financial services, pharmaceuticals,
          entertainment, retail and enterprise applications for internal and
          customer facing web, desktop and mobile applications.
        </p>
        <p>
          I am an avid photographer, artist, creative writer and also interested
          in filmmaking. I think that any kind of art helps one to master the
          act of observing, for it is through observing that one gets to learn
          about their surroundings, appreciate the beauty of the things around,
          identify things that could be improved and create useful experiences.
        </p>
        <p>
          My portfolio is a mixed bag of projects showcasing the various skills
          and interests I have. I draw a lot of inspiration from traveling,
          reading and cinema. A lot of my project ideas have developed from
          things I have experienced in my travels, people I have met and the
          books I have read.
        </p>
      </div>
    </div>
  </Layout>
)

export const Head: HeadFC<DataProps> = () => (
  <Seo title="Design Portfolio - Shubhi Shrivastava" />
)

export default LandingPage
